import type { LucideIcon } from 'lucide-react';
import {
  TvIcon,
  TradeIcon,
  TradeActiveIcon,
  SquareIcon,
  SwapIcon,
  SwapActiveIcon,
  TvActiveIcon,
  SquareActiveIcon,
  MarketIcon,
  MarketActiveIcon,
  ScanIcon,
  ScanActiveIcon,
  GroupIcon,
  GroupActiveIcon,
  LiveCenterIcon,
  LiveCenterActiveIcon,
  InviteGiftIcon,
  InviteGiftActiveIcon,
  UserCenterIcon,
  UserCenterActiveIcon,
  WalletIcon,
  WalletActiveIcon,
  PredictIcon,
  PredictActiveIcon,
  ExploreIcon,
  ExploreActiveIcon,
} from '@/app/const/svg';

// 定义侧边栏菜单项的类型
export interface SideBarMenuItem {
  icon: LucideIcon | React.ComponentType<{ className?: string; fill?: string; [key: string]: any }>;
  activeIcon?: LucideIcon | React.ComponentType<{ className?: string; fill?: string; [key: string]: any }>;
  text: string;
  path: string;
  paths: string[];
  size?: string;
  isSoon?: boolean;
  isNew?: boolean;
  hidden?: boolean;
  needLogin?: boolean;
  showUnRead?: boolean;
}

// 定义侧边栏菜单项数组类型（二维数组）
export type SideBarItemType = SideBarMenuItem[][];

// 用于 handleTabChange 的参数类型，path 是必需的，其他都是可选的
export type SideBarMenuItemInput = Pick<SideBarMenuItem, 'path'> & Partial<Omit<SideBarMenuItem, 'path'>>;

/**
 * 获取侧边栏配置
 * @param t 国际化函数
 * @param isLoggedIn 是否已登录
 * @param userInfo 用户信息
 * @returns 侧边栏配置数组
 */
export function getSidebarConfig(
  t: (key: string) => string,
  isLoggedIn: boolean = false,
  userInfo?: { isStreamer?: number } | null,
  isMobile: boolean = false
): SideBarItemType {
  return [
    [
      {
        icon: ExploreIcon,
        activeIcon: ExploreActiveIcon,
        text: t('header.explore'),
        path: 'discover',
        paths: ['discover', ''],
      },
      {
        icon: TvIcon,
        activeIcon: TvActiveIcon,
        text: t('header.live'),
        path: 'live',
        paths: ['live'],
      },
      {
        icon: SquareIcon,
        activeIcon: SquareActiveIcon,
        text: t('header.square'),
        path: 'square',
        paths: ['detail', 'square'],
        size: 'size-5',
      },
    ],
    [
      {
        icon: PredictIcon,
        activeIcon: PredictActiveIcon,
        text: t('header.predict'),
        path: 'predict',
        paths: ['predict'],
        isNew: true,
        needLogin: true,
      },
      {
        icon: MarketIcon,
        activeIcon: MarketActiveIcon,
        text: t('header.token'),
        path: 'markets',
        paths: ['markets'],
        hidden: true,
        needLogin: true,
      },
      {
        icon: TradeIcon,
        activeIcon: TradeActiveIcon,
        text: t('header.perps'),
        path: 'perps',
        paths: ['perps'],
        needLogin: true,
        size: 'size-5',
      },
      {
        icon: ScanIcon,
        activeIcon: ScanActiveIcon,
        text: t('header.scan'),
        path: 'scan',
        paths: ['scan'],
        isSoon: true,
        hidden: true,
        needLogin: true,
      },
      {
        icon: SwapIcon,
        activeIcon: SwapActiveIcon,
        text: t('header.swap'),
        path: 'swap',
        paths: ['swap'],
        needLogin: true,
      },
    ],
    [
      {
        icon: InviteGiftIcon,
        activeIcon: InviteGiftActiveIcon,
        text: t('header.referral'),
        path: 'referral',
        paths: ['referral'],
        needLogin: true,  
      },
      {
        icon: GroupIcon,
        activeIcon: GroupActiveIcon,
        text: t('message.menu.title'),
        path: 'message',
        needLogin: true,
        showUnRead: true,
        paths: ['message'],
      },
      {
        icon: UserCenterIcon,
        activeIcon: UserCenterActiveIcon,
        text: t('me.user'),
        path: 'me',
        paths: ['me'],
        needLogin: true,
      },
      {
        icon: WalletIcon,
        activeIcon: WalletActiveIcon,
        text: t('header.assetCenter'),
        path: 'portfolio',
        paths: ['portfolio'],
        needLogin: true,
      },
      {
        icon: LiveCenterIcon,
        activeIcon: LiveCenterActiveIcon,
        text: t('me.liveAdmin'),
        path: 'admin',
        paths: ['admin'],
        needLogin: true,
        hidden: !isLoggedIn || userInfo?.isStreamer !== 1 || isMobile,
      },
    ],
  ];
}
